import * as React from "react";
import { Icon } from "baseui/icon";
import { IconProps } from "baseui/icon";

const Visible: React.FC<IconProps> = (props) => (
  <Icon {...props}>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.9259 9.76333C19.7684 9.53415 15.9834 4.16656 9.99995 4.16656C4.86569 4.16656 0.29062 9.50333 0.0981168 9.73083C-0.0327056 9.88583 -0.0327056 10.1133 0.0981168 10.2692C0.29062 10.4967 4.86569 15.8334 9.99995 15.8334C15.1342 15.8334 19.7092 10.4967 19.9017 10.2692C20.0226 10.1258 20.0334 9.91833 19.9259 9.76333ZM9.99995 15.0001C5.88407 15.0001 1.97065 11.075 0.97649 10C1.96901 8.92418 5.87825 4.99994 9.99995 4.99994C14.8158 4.99994 18.2151 8.91918 19.0451 9.97752C18.0867 11.0184 14.1508 15.0001 9.99995 15.0001Z"
        fill="black"
      />
      <path
        d="M9.99988 6.66663C8.16153 6.66663 6.6665 8.16165 6.6665 10C6.6665 11.8384 8.16153 13.3334 9.99988 13.3334C11.8382 13.3334 13.3333 11.8384 13.3333 10C13.3333 8.16165 11.8382 6.66663 9.99988 6.66663ZM9.99988 12.5001C8.62154 12.5001 7.49984 11.3784 7.49984 10C7.49984 8.6217 8.62154 7.5 9.99988 7.5C11.3782 7.5 12.4999 8.6217 12.4999 10C12.4999 11.3784 11.3782 12.5001 9.99988 12.5001Z"
        fill="black"
      />
    </svg>
  </Icon>
);

export default Visible;
